// Using Context Provider
// https://dmitripavlutin.com/react-context-and-usecontext/
import React from "react";

const MenuProvider = React.createContext(false);

export default MenuProvider;